<template>
  <div>
    <h1></h1>

    <div class="row">
      <div class="col-md-12">
        <div class="portlet light portlet-fit bordered">
          <div class="portlet-title">
            <div class="caption">
              <i class="icon-trophy font-green"></i>
              <span class="caption-subject font-green bold uppercase">Popular deals</span>
            </div>
          </div>
          <div class="portlet-body">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group">
                  <select id="period"
                          class="form-control input-sm"
                          @change="period = $event.target.value"
                          style="width: 100%">
                    <option value="today">Today</option>
                    <option value="yesterday">Yesterday</option>
                    <option value="this_month">This month</option>
                    <option value="previous_month">Previous month</option>
                  </select>
                </div>
              </div>
            </div>

            <transition name="el-zoom-in-center" mode="in-out">
              <div class="mt-element-card flex mt-element-overlay" v-if="deals[period].length">
                <tuango-deal-card v-for="(deal, index) in deals[period]" :key="deal.id"
                                  :dealId="deal.id"
                                  :title="deal.title"
                                  :description="deal.description|truncate(150)"
                                  :img="deal.images ? deal.images[0].url : ''"
                                  :nbClaims="activeStats[index]['cnt']"
                                  :dealData="deal"
                ></tuango-deal-card>
              </div>
            </transition>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  /* ============
   * Popular Deals Page
   * ============
   *
   */
  import _ from 'lodash'

  import PopularDealsProxy from '@/app/proxies/PopularDealsMetricsProxy'
  import DealProxy from '@/app/proxies/DealProxy'
  import DealTransformer from '@/app/transformers/DealTransformer'

  import TuangoDealCard from '@/app/components/deal/DealCard'

  export default {
    components: {
      TuangoDealCard
    },
    data () {
      return {
        popularDealsStatsProvider: null,
        dealProvider: null,
        stats: [],
        period: 'today',
        deals: {
          today: [],
          yesterday: [],
          this_month: [],
          previous_month: []
        }
      }
    },
    computed: {
      // statistics for selected period
      activeStats () {
        return this.stats[this.period] ? _.orderBy(this.stats[this.period], ['cnt'], ['desc']) : []
      }
    },
    watch: {
      activeStats () {
        if (this.deals[this.period].length) return

        this.getDeals()
          .then(res => {
            this.deals[this.period] = res
          })
          .catch(err => {
            console.log(err)
          })
      }
    },
    methods: {
      getDeals () {
        return Promise.all(
          this.activeStats.map(dealStats => this.dealProvider.find(dealStats.id))
        )
          .then(results => {
            return Promise.all(results.map(res => {
              return DealTransformer.fetch(res.data)
            }))
          })
          .then(results => {
            // order by popularity
            return _.sortBy(results, 'cnt').reverse()
          })
      }
    },
    created () {
      this.dealProvider = new DealProxy()
      this.popularDealsStatsProvider = new PopularDealsProxy()
      this.popularDealsStatsProvider.all()
        .then(res => {
          this.stats = JSON.parse(res.data.data)
        })
        .catch(err => {
          console.log(err)
        })
    }
  }
</script>



// WEBPACK FOOTER //
// src/app/pages/Metrics/PopularDeals.vue